<template>
  <v-img
    :src="require('@/assets/images/logo.png')"
    max-width="60"
    :width="width"
    :class="isClickable ? 'clickable' : ''"
    @click="goHome"
  />
</template>

<script>
import links from '@/constants/links';
export default {
    name: 'AppLogo',
    props: {
        width: {
            required: false,
            default: 'auto',
            type: [String, Number]
        },
        url: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        isClickable () {
            return this.$route.name !== 'home';
        }
    },
    methods: {
        goHome () {
            if (this.isClickable) {
                if (this.url) {
                    window.open(links.SZP, '_blank');
                } else {
                    this.$router.push({ name: 'home' });
                }
            }
        }
    }
};
</script>

<style scoped></style>
